// extracted by mini-css-extract-plugin
export default {"sliderContainer":"RangeSlider_sliderContainer__FfHOU","slider":"RangeSlider_slider__UXjLj","labels":"RangeSlider_labels__nEwjl"};